import type { SecuredFieldsCreditCardDetails } from "@jti/fe-common";

export const formatCardSummary = ({ cardBrand, maskedCardNumber }: SecuredFieldsCreditCardDetails): string => {
  const capitalized = cardBrand.charAt(0).toUpperCase() + cardBrand.slice(1).toLowerCase();
  const lastFourDigits = maskedCardNumber.slice(-4);
  return `${capitalized} *${lastFourDigits}`;
};
